import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Keyboard } from "./keyboard-CML2Vzkw.js";
import { t as Mousewheel } from "./mousewheel-C-gtMpkm.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
//#region src/scripts/extenders/image-blocks.js
var ImageBlocks = class extends HTMLElement {
	constructor() {
		super();
		this.swiper = null;
	}
	connectedCallback() {
		if (this.swiper) return;
		const swiperHolder = this.querySelector(".swiper");
		const previousButton = this.querySelector(".swiper-button-previous");
		const nextButton = this.querySelector(".swiper-button-next");
		if (!swiperHolder) return;
		this.swiper = new Swiper(swiperHolder, {
			modules: [
				Keyboard,
				Mousewheel,
				Navigation
			],
			direction: "horizontal",
			keyboard: { enabled: true },
			mousewheel: { forceToAxis: true },
			navigation: {
				prevEl: previousButton,
				nextEl: nextButton
			},
			slidesPerView: 1.2,
			spaceBetween: 8,
			watchOverflow: true,
			breakpoints: { 1024: {
				slidesPerView: 4,
				spaceBetween: 8
			} }
		});
	}
	disconnectedCallback() {
		if (!this.swiper) return;
		this.swiper.destroy(true, true);
		this.swiper = null;
	}
};
if (customElements.get("image-blocks") === void 0) customElements.define("image-blocks", ImageBlocks);
//#endregion
